import React from "react";
import Layout from "../../Layout.json";
import Double from "../../../layoutsView/Double/Double";
import DoubleSubtitle from "../../../layoutsView/DoubleSubtitle/DoubleSubtitle";
import Normal from "../../../layoutsView/Normal/Normal";
import Chart from "../../../layoutsView/Chart/FullChart";
import NormalChart from "../../../layoutsView/NormalChart/NormalChart";
import SubtitleChart from "../../../layoutsView/SubtitleChart/SubtitleChart";
import Picture from "../../../layoutsView/Picture/Picture";
import PictureLeft from "../../../layoutsView/PictureLeft/PictureLeft";
import PictureRight from "../../../layoutsView/PictureRight/PictureRight";

export const getViewLayout = (id, layoutType, data) => {
	switch (layoutType) {
		case Layout.normal:
			return <Normal id={id} data={data} />;

		case Layout.double:
			return <Double id={id} data={data} />;

		case Layout.doubleSubtitle:
			return <DoubleSubtitle id={id} data={data} />;

		case Layout.picture:
			return <Picture id={id} data={data} />;

		case Layout.pictureLeft:
			return <PictureLeft id={id} data={data} />;

		case Layout.pictureRight:
			return <PictureRight id={id} data={data} />;

		case Layout.chart:
			return <Chart id={id} data={data} />;

		case Layout.normalChart:
			return <NormalChart id={id} data={data} />;

		case Layout.subtitleChart:
			return <SubtitleChart id={id} data={data} />;

		default:
			break;
	}
};
